import regionReducer from './regionReducer';

export * from './regionActions';
export default regionReducer;
